import { Automations } from '@sweep-io/sweep-design/dist/icons/Automations';
import { Binoculars } from '@sweep-io/sweep-design/dist/icons/Binoculars';
import { Devops } from '@sweep-io/sweep-design/dist/icons/Devops';
import { File } from '@sweep-io/sweep-design/dist/icons/File';
import { PlaybookAlert } from '@sweep-io/sweep-design/dist/icons/PlaybookAlert';
import { Reporting } from '@sweep-io/sweep-design/dist/icons/Reporting';
import { Sparkle } from '@sweep-io/sweep-design/dist/icons/Sparkle';
import { Target } from '@sweep-io/sweep-design/dist/icons/Target';
import { Users } from '@sweep-io/sweep-design/dist/icons/Users';
import { Rule } from '@sweep-io/sweep-design/dist/icons/Rule';
import { Megaphone } from '@sweep-io/sweep-design/dist/icons/Megaphone';
import { Productivity } from '@sweep-io/sweep-design/dist/icons/Productivity';
import { appRoutes } from '../../../../constants/appRoutes';
import House from '../icons/House.svg?react';
import Cube from '../icons/Cube.svg?react';
import Flows from '../icons/Flows.svg?react';
import ImpactAnalysis from '../icons/ImpactAnalysis.svg?react';
import type { MainMenuItem, MenuColumn, MenuItem } from './types';
import { colors } from '@sweep-io/sweep-design';
import { Folder } from '@sweep-io/sweep-design/dist/icons/Folder';
import { Chats } from '@sweep-io/sweep-design/dist/icons/Chats';

enum AppsMenuSections {
  Analyze = 'Analyze',
  Optimize = 'Control',
  GTMHub = 'GTM Hub',
  AddOns = 'Add ons',
}

const iconColor = colors.blue[500];

export const orgMigrationMenuItem: MenuItem = {
  label: 'Org Migration',
  icon: <Productivity color={iconColor} size="medium" />,
  route: appRoutes.orgMigration.route,
};

//waiting for proper definition from product
export const analyseAppsMenu: MenuColumn[] = [
  {
    columnId: AppsMenuSections.Analyze,
    //no columnLabel here on purpose
    menuItems: [
      {
        label: 'Documentation',
        icon: <Binoculars color={iconColor} size="medium" />,
        route: appRoutes.documentation.route,
        withEnvSuffix: true,
      },
      {
        label: 'SF Change Feed',
        icon: <File color={iconColor} size="medium" />,
        route: appRoutes.sfChangeFeed.route,
      },
    ],
  },
];

export const buildAppsColumns: MenuColumn[] = [
  {
    columnLabel: AppsMenuSections.Optimize,
    columnId: AppsMenuSections.Optimize,
    menuItems: [
      {
        label: 'Automations',
        icon: <Automations color={iconColor} size="medium" />,
        route: appRoutes.automations.route,
        withEnvSuffix: true,
      },
      {
        label: 'Dedupe & Matching',
        icon: <Target color={iconColor} size="medium" />,
        route: appRoutes.dedup.route,
        withEnvSuffix: true,
      },
      {
        label: 'Rollups',
        icon: <Rule color={iconColor} size="medium" />,
        route: appRoutes.rollups.route,
        withEnvSuffix: true,
      },
      {
        label: 'Compare & Deploy',
        icon: <Devops color={iconColor} size="medium" />,
        route: appRoutes.devopsCenter.route,
      },
      {
        label: 'Reporting',
        icon: <Reporting color={iconColor} size="medium" />,
        route: appRoutes.reports.route,
      },
    ],
  },
  {
    columnLabel: AppsMenuSections.GTMHub,
    columnId: AppsMenuSections.GTMHub,
    menuItems: [
      {
        label: 'Routing',
        icon: <Users color={iconColor} size="medium" />,
        route: appRoutes.routing.route,
        withEnvSuffix: true,
      },
      {
        label: 'Alerts',
        icon: <PlaybookAlert color={iconColor} size="medium" />,
        route: appRoutes.alerts.route,
        withEnvSuffix: true,
      },
      {
        subMenuId: AppsMenuSections.AddOns,
        label: 'Add ons',
        icon: <></>,
        route: 'add-ons', //doesn't have a real route
        subMenuItems: [
          {
            label: 'Marketing Management',
            icon: <Megaphone color={iconColor} size="medium" />,
            route: appRoutes.marketingManagement.route,
          },
          {
            label: 'User Support Agent',
            icon: <Sparkle color={iconColor} size="medium" />,
            route: appRoutes.aiAssistant.route,
          },
        ],
      },
    ],
  },
];

const agenticLayerMenuColumns: MenuColumn[] = [
  {
    columnId: 'agentic-layer',
    menuItems: [
      {
        label: 'Agents',
        icon: <Chats color={iconColor} size="medium" />,
        route: appRoutes.agenticLayer.route,
        withEnvSuffix: true,
      },
      {
        label: 'Playbooks',
        icon: <Folder color={iconColor} size="medium" />,
        route: appRoutes.projects.route,
        withEnvSuffix: true,
      },
    ],
  },
];

export const mainMenuItems: MainMenuItem[] = [
  {
    label: 'Home',
    Icon: <House />,
    route: appRoutes.getStarted.route,
  },
  {
    label: 'Visual Workspace',
    Icon: <Flows />,
    route: appRoutes.funnelMapsPage.route,
  },
  {
    label: 'Impact Analysis',
    Icon: <ImpactAnalysis />,
    route: 'apps1', //doesn't have a real route
    menuColumns: analyseAppsMenu,
  },
  {
    label: 'Build',
    Icon: <Cube />,
    route: 'apps2', //doesn't have a real route
    menuColumns: buildAppsColumns,
  },
  {
    label: 'Agentic Layer',
    Icon: <Chats />,
    route: appRoutes.agenticLayer.route,
    menuColumns: agenticLayerMenuColumns,
  },
];
